import { cn } from '@/lib/utils';
import type * as React from 'react';

interface InputProps extends React.ComponentProps<'input'> {
  leading?: React.ReactNode;
  trailing?: React.ReactNode;
}

function Input({ className, type, leading, trailing, ...props }: InputProps) {
  return (
    <div
      className={cn(
        'group flex h-12 w-full items-center rounded-md border bg-white px-4 transition-[color,box-shadow]',
        'dark:bg-input/30',
        'aria-invalid:border-destructive',
        className,
      )}>
      {leading}

      <input
        type={type}
        data-slot="input"
        className={cn(
          'file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground',
          'min-w-0 flex-1 bg-transparent text-base outline-none',
          'file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium',
          'disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        )}
        {...props}
      />

      {trailing}
    </div>
  );
}

export { Input };
